import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px;

  /* faz os controles nativos (checkbox, autofill, scrollbar) seguirem o tema */
  color-scheme: ${({ theme }) => (theme.isDark ? 'dark' : 'light')};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.textColor};
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  font-size: 14px;
  background-color: ${({ theme }) => theme.inputBackground};
  color: ${({ theme }) => theme.textColor};

  &::placeholder {
    color: ${({ theme }) => theme.gray};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }

  &:disabled {
    background-color: ${({ theme }) =>
      theme.isDark ? 'rgba(255, 255, 255, 0.06)' : theme.lightGrayColor};
    border-style: dashed;
    color: ${({ theme }) => theme.gray};
    cursor: not-allowed;
  }
`;

export const Ajuda = styled.small`
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.gray};
`;

export const CheckboxLinha = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: fit-content;
  font-size: 14px;
  color: ${({ theme }) => theme.textColor};
  cursor: pointer;
  user-select: none;

  /*
   * O globalStyles aplica input { width: 100%; padding: 10px; border: ... },
   * o que estica o checkbox pela linha inteira: o glifo fica centralizado e o
   * texto e empurrado para a ponta. Aqui o checkbox volta ao tamanho dele.
   */
  input[type='checkbox'] {
    flex: 0 0 auto;
    width: 16px;
    min-width: 16px;
    height: 16px;
    margin: 0;
    padding: 0;
    border-radius: 3px;
    accent-color: ${({ theme }) => theme.primaryColor};
    cursor: pointer;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }
`;
